import { createClient } from '@supabase/supabase-js'

// Use environment variables with fallbacks
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ccicgmkstfczcrdvduzz.supabase.co'
const supabaseServiceKey = process.env.REACT_APP_SUPABASE_SERVICE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNjaWNnbWtzdGZjemNyZHZkdXp6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI4MDQ2OTUsImV4cCI6MjA4ODM4MDY5NX0.5b30ZI432eWEuVlgNqOVpJTiEQ3r2C68ER4X7JAKtFk'

console.log('🔧 Supabase Admin Configuration:')
console.log('Environment:', process.env.NODE_ENV || 'development')
console.log('URL:', supabaseUrl)
console.log('Service Key:', supabaseServiceKey ? '✓ Exists' : '✗ Missing')

if (!supabaseUrl || !supabaseServiceKey) {
  throw new Error('❌ Missing Supabase credentials')
}

export const supabaseAdmin = createClient(supabaseUrl, supabaseServiceKey, {
  auth: {
    autoRefreshToken: false,
    persistSession: false,
    detectSessionInUrl: false
  },
  db: {
    schema: 'public'
  }
})

console.log('✅ Supabase admin client initialized successfully')